import CheckboxQuestion from './types/CheckboxQuestion';
import DropdownQuestion from './types/DropdownQuestion';
import EmailQuestion from './types/EmailQuestion';
import FileQuestion from './types/FileQuestion';
import LongQuestion from './types/LongQuestion';
import MultiSelectQuestion from './types/MultiSelectQuestion';
import NumberQuestion from './types/NumberQuestion';
import ShortQuestion from './types/ShortQuestion';
import WysiwygQuestion from './types/WysiwygQuestion';

export default {
    CheckboxQuestion,
    DropdownQuestion,
    EmailQuestion,
    FileQuestion,
    LongQuestion,
    MultiSelectQuestion,
    NumberQuestion,
    ShortQuestion,
    WysiwygQuestion
};
